import { isRefundedPayment } from "../../../sales/Invoice/refundedPayment";
const amount = (value) => {
  const number = value && typeof value === "object"
    ? Number(value.amount_minor) / 100
    : Number(value);
  return Number.isFinite(number) ? number : null;
};

export const clientInvoicePaymentRows = (payments) => (Array.isArray(payments) ? payments : [])
  .filter((payment) => {
    const status = String(payment?.status || "").toLowerCase();
    return payment?.type === "Sale"
      && !["failed", "pending", "declined", "authorized"].includes(status)
      && amount(payment.amount) !== null;
  })
  .map((payment) => ({
    id: payment.id,
    ...(payment.amount && typeof payment.amount === "object" && Object.prototype.hasOwnProperty.call(payment.amount, "currency")
      ? {currency: payment.amount.currency}
      : Object.prototype.hasOwnProperty.call(payment, "currency") ? {currency:payment.currency} : {}),
    ...(isRefundedPayment(payment) ? { status: "REFUNDED" } : {}),
    method: payment.paidby || payment.paid_by || "Payment",
    amount: amount(payment.amount).toFixed(2),
  }));

export const clientInvoiceRefundRows = payments => (Array.isArray(payments) ? payments : [])
  .filter(payment => ['depositrefund','salerefund'].includes(String(payment?.type || '').toLowerCase())
    && ['paid','succeeded','completed'].includes(String(payment?.status || '').toLowerCase())
    && amount(payment.amount) !== null)
  .map(payment => ({...payment, ...(payment.amount?.currency ? {currency:payment.amount.currency} : {}), amount: Math.abs(amount(payment.amount)), paidby:payment.paidby || payment.paid_by || 'Payment'}));
